interface AppConstInterface {
  env: string;
  API?: string;
  AUTH_API?: string;
  CHECK_API?: string;
  wxAppId?: string;
  alipayAppId?: string;
  weiboAPPKey?: string;
  customizedCardGuid?: string;
  UBT_API?: string;
  LIFE_API?: string;
  TAXI_API?: string;
  BIKE_API?: string;
  EBIKE_API?: string;
  HAPPYGW_API?: string;
  UPLOAD_API?: string;
}
const appConst: AppConstInterface = {
  env: 'pro',
};

export const setConst = (env: string): void => {
  appConst.env = env;

  if (env === 'pro') {
    appConst.API = 'https://api.hellobike.com/api';
    appConst.AUTH_API = 'https://api.hellobike.com/auth';
    appConst.CHECK_API = 'https://api.hellobike.com/orderCheck';
    appConst.wxAppId = 'wxb2315cf308c9a24d';
    appConst.alipayAppId = '2016092701982277';
    appConst.weiboAPPKey = '918976056';
    appConst.customizedCardGuid = '00bcbf7e8b4648b282974fff5a7c7250';
    appConst.UBT_API = 'https://ubt.hellobike.com/yukon_logging';
    appConst.LIFE_API = 'https://mapi.hellobike.com/api';
    appConst.TAXI_API = 'https://taxiapi.hellobike.com/api';
    appConst.BIKE_API = 'https://bike.hellobike.com/api';
    appConst.EBIKE_API = 'https://ebike.hellobike.com/api';
    appConst.HAPPYGW_API = 'https://gameapi.hellobike.com/api';
    appConst.UPLOAD_API = 'https://api.hellobike.com/user/uploadImg';
  } else if (env === 'uat') {
    appConst.API = 'https://uat-api.hellobike.com/api';
    appConst.AUTH_API = 'https://uat-api.hellobike.com/auth';
    appConst.wxAppId = 'wxb2315cf308c9a24d';
    appConst.alipayAppId = '2016092701982277';
    appConst.weiboAPPKey = '918976056';
    appConst.CHECK_API = 'https://uat-api.hellobike.com/orderCheck';
    appConst.customizedCardGuid = 'ba03b81e27a24a6c996e9f23dd67894e';
    appConst.UBT_API = 'https://uat-ubt.hellobike.com/yukon_logging';
    appConst.LIFE_API = 'https://uat-mapi.hellobike.com/api';
    appConst.TAXI_API = 'https://uat-taxiapi.hellobike.com/api';
    appConst.BIKE_API = 'https://uat-bike.hellobike.com/api';
    appConst.EBIKE_API = 'https://uat-ebike.hellobike.com/api';
    appConst.HAPPYGW_API = 'https://uat-gameapi.hellobike.com/api';
    appConst.UPLOAD_API = 'https://uat-api.hellobike.com/user/uploadImg';
  } else if (env === 'dev' || env === 'test') {
    appConst.API = 'https://newdev-api.hellobike.com/api';
    // appConst.AUTH_API = 'https://easybike.cheyaoshi.com/auth';
    appConst.AUTH_API = 'https://newdev-api.hellobike.com/api';
    appConst.wxAppId = 'wxb2315cf308c9a24d';
    appConst.alipayAppId = '2016092701982277';
    appConst.weiboAPPKey = '918976056';
    appConst.CHECK_API = 'https://easybike.cheyaoshi.com/orderCheck';
    appConst.LIFE_API = 'https://test-mapi.hellobike.com/api';
    // appConst.UBT_API = 'https://dev-ubt.hellobike.com/yukon_logging';
    // appConst.TAXI_API = 'http://47.96.27.158:8080/api';
    appConst.TAXI_API = 'https://fat-taxiapi.hellobike.com/api';
    appConst.BIKE_API = 'https://newdev-bikegw.hellobike.com/api';
    appConst.UBT_API = 'https://dev-ubt.hellobike.com/yukon_logging';
    appConst.EBIKE_API = 'https://newdev-evbikegw.hellobike.com/api';
    appConst.HAPPYGW_API = 'https://newdev-happygw.hellobike.com/api';
  } else if (env === 'fat' || env === 'fat2') {
    appConst.API = 'https://fat-api.hellobike.com/api';
    appConst.AUTH_API = 'https://fat-api.hellobike.com/auth';
    appConst.CHECK_API = 'https://fat-api.hellobike.com/orderCheck';
    appConst.UPLOAD_API = 'https://fat-api.hellobike.com/user/uploadImg';
    appConst.wxAppId = 'wxb2315cf308c9a24d';
    appConst.alipayAppId = '2016092701982277';
    appConst.weiboAPPKey = '918976056';
    appConst.customizedCardGuid = 'e13b4bfd6cc748ba97ba3c1d4cbc9ddf';
    appConst.LIFE_API = 'https://fat-mapi.hellobike.com/api';
    appConst.UBT_API = 'https://fat-ubt.hellobike.com/yukon_logging';
    appConst.TAXI_API = 'https://fat-taxiapi.hellobike.com/api';
    appConst.BIKE_API = 'https://fat-bike.hellobike.com/api';
    appConst.EBIKE_API = 'https://fat-ebike.hellobike.com/api';
    appConst.HAPPYGW_API = 'https://fat-gameapi.hellobike.com/api';
  } else if (env === 'pre') {
    appConst.API = 'https://pre-api.hellobike.com/api';
    appConst.AUTH_API = 'https://pre-api.hellobike.com/auth';
    appConst.wxAppId = 'wxb2315cf308c9a24d';
    appConst.alipayAppId = '2016092701982277';
    appConst.weiboAPPKey = '918976056';
    appConst.CHECK_API = 'https://pre-api.hellobike.com/orderCheck';
    appConst.customizedCardGuid = 'ba03b81e27a24a6c996e9f23dd67894e';
    appConst.UBT_API = 'https://pre-ubt.hellobike.com/yukon_logging';
    appConst.LIFE_API = 'https://pre.mapi.ttbike.com.cn/api';
    appConst.TAXI_API = 'https://pre.taxiapi.hellobike.com/api';
    appConst.BIKE_API = 'https://pre-bike.hellobike.com/api';
    appConst.UPLOAD_API = 'https://pre-api.hellobike.com/user/uploadImg';
  } else if (env === 'vuat') {
    appConst.API = 'https://vuat-api.hellobike.com/api';
    appConst.AUTH_API = 'https://vuat-api.hellobike.com/auth';
    appConst.wxAppId = 'wxb2315cf308c9a24d';
    appConst.alipayAppId = '2016092701982277';
    appConst.weiboAPPKey = '918976056';
    appConst.CHECK_API = 'https://vuat-api.hellobike.com/orderCheck';
    appConst.customizedCardGuid = 'ba03b81e27a24a6c996e9f23dd67894e';
    appConst.UBT_API = 'https://uat-ubt.hellobike.com/yukon_logging';
    appConst.LIFE_API = 'https://vuat.mapi.ttbike.com.cn/api';
    appConst.TAXI_API = 'https://vuat.taxiapi.hellobike.com/api';
    appConst.BIKE_API = 'https://uat-bike.hellobike.com/api';
    appConst.UPLOAD_API = 'https://vuat-api.hellobike.com/user/uploadImg';
  }
};

setConst(process.env.REACT_APP_ENV || 'fat');

const sysTag = 'fat_group2';
export const getSysTag = (): string | undefined => {
  if (appConst.env === 'fat2') {
    return sysTag;
  }
  if (appConst.env === 'test') {
    return 'localTest';
  }
  return undefined;
};

export default appConst;
